import React from 'react';

const MySkinLogo = ({ size = 'md', showText = false, className = '' }) => {
  const sizeClasses = {
    sm: 'w-20 h-20',
    md: 'w-28 h-28',
    lg: 'w-36 h-36',
    xl: 'w-48 h-48',
    '2xl': 'w-56 h-56'
  };

  return (
    <div className={`flex flex-col items-center ${className}`}>
      {/* Logo */}
      <img
        src="/assets/LOGO.svg"
        alt="my-skin.ai"
        className={`${sizeClasses[size]} object-cover`}
      />

      {/* Text if needed */}
      {showText && (
        <div className="mt-3 text-center">
          <div className="text-white font-bold text-lg tracking-wide">my-skin.ai</div>
          <div className="text-white/80 text-sm">Your Trusted AI Skin Analysis Partner</div>
          <div className="text-white/70 text-xs mt-2">
            100% Private • Never Stored • Deleted Immediately
          </div>
        </div>
      )}
    </div>
  );
};

export default MySkinLogo;
